import { spacing6 } from "@litbase/alexandria";

export const tabSpacing = spacing6;
